import React, { useEffect } from 'react';
import { initMetaPixel } from './hooks/useMetaPixel';
import { CountdownTimer } from './components/CountdownTimer';
import { FloatingTestimonials } from './components/FloatingTestimonials';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { ValueStackSection } from './components/ValueStackSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { AuthoritySection } from './components/AuthoritySection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTASection } from './components/FinalCTASection';
import { FAQSection } from './components/FAQSection';
import { FooterSection } from './components/FooterSection';
import { GoldDivider } from './components/GoldDivider';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-black" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <FloatingTestimonials data-id="element-2" />
      <HeroSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <div className="bg-brand-black" data-id="element-5">
        <GoldDivider data-id="element-6" />
      </div>
      <MechanismSection data-id="element-7" />
      <div className="bg-brand-black" data-id="element-8">
        <GoldDivider data-id="element-9" />
      </div>
      <ProductSection data-id="element-10" />
      <ValueStackSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <div className="bg-brand-black" data-id="element-13">
        <GoldDivider data-id="element-14" />
      </div>
      <ForWhoSection data-id="element-15" />
      <div className="bg-brand-black" data-id="element-16">
        <GoldDivider data-id="element-17" />
      </div>
      <AuthoritySection data-id="element-18" />
      <GuaranteeSection data-id="element-19" />
      <FinalCTASection data-id="element-20" />
      <FAQSection data-id="element-21" />
      <FooterSection data-id="element-22" />
    </div>;
}